module.exports = __webpack_public_path__ + "73d324446f3fa74d12a7bfb8bf2fb7c6.MP3";